<!-- //
大屏列表
@auth xuyd
@date 2024-05-01
//-->
<template>
  <page-layout layout="C">
    <div class="layout-search" style="display: flex; flex-direction: row; justify-content: space-between">
      <el-form @submit.native.prevent ref="refForm" :model="queryParams" size="small" :inline="true" label-width="100px">
        <el-form-item prop="pageName">
          <el-input
              v-model="queryParams.pageName"
              placeholder="请输入大屏名称"
              style="width: 300px;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button size="small" type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display:flex; justify-content: right;">
        <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus">新建大屏</el-button>
      </div>
    </div>
    <!-- 结果区域 -->
    <div class="layout-result" style="height: calc(100% - 63px);">
      <el-row :gutter="20" class="list-container">
        <el-col style="width: 380px; height: 250px;" v-for="(item, index) in list" :key="index">
          <div class="box">
            <div class="header">
              {{ item.pageName }}
            </div>
            <div class="footer">
              <div class="label">{{ $util.parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}') }}</div>
              <div>
                <el-button size="small" type="text" class="el-icon-delete button" @click="handleDelete(item)">删除</el-button>
                <el-button size="small" type="text" class="el-icon-view button" @click="handlePreview(item)">预览</el-button>
                <el-button size="small" type="text" class="el-icon-edit button" @click="handleDesign(item)">设计</el-button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <pagination :total="total" :pageNum.sync="queryParams.pageNum" :pageSize.sync="queryParams.pageSize"
                  @pagination="getList"/>
    </div>
    <AddDlg ref="refAddDlg"/>
  </page-layout>
</template>

<script>
import DataScreenApi from '@/api/datavisual/dataScreen.api.js';
import AddDlg from './add';

export default {
  name: 'ViewScreenList',
  components: {AddDlg},
  data() {
    return {
      list: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pageName: null,
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      DataScreenApi.searchScreenList(this.queryParams).then(resp => {
        this.list = resp.data.records;
        this.total = resp.data.total;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm('refForm');
      this.handleQuery();
    },

    /**
     * 新增
     */
    handleAdd() {
      this.$refs.refAddDlg.showModal({
        data: {},
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 编辑
     */
    handleEdit(row) {
      this.$refs.refAddDlg.showModal({
        data: {...row},
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 删除
     * @param row
     */
    handleDelete(row) {
      this.$modal.confirm(`确定要删除【${row.pageName}】吗？`).then(() => {
        DataScreenApi.deleteScreen(row.id).then(resp => {
          this.$modal.msgSuccess('删除成功');
          this.getList();
        })
      })
    },

    /**
     * 预览
     * @param row
     */
    handlePreview(row) {
      let routeData = this.$router.resolve({name: 'ViewScreenPreview'});
      window.open(routeData.href + '?pageId=' + row.id, '_blank');
    },

    /**
     * 跳转
     * @param row
     */
    handleDesign(row) {
      let routeData = this.$router.resolve({name: 'ViewScreenDesign',});
      window.open(routeData.href + '?pageId=' + row.id, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
.list-container {
  flex: 1;
}
.box {
  width: 350px;
  height: 200px;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  background-image: url("../assets/img/screen_bg.jpg") ;
  background-repeat: no-repeat;
  background-size: cover;

  .header,
  .footer {
    width: 100%;
    height: 40px;
    text-align: center;
    position: absolute;
    left: 0;
  }

  .header {
    font-size: 16px;
    font-weight: 600;
    color: #DDDDDD;
    background-color: rgba(0, 0, 0, 0.3);
    padding: 10px 20px;
    top: 0;
  }

  .footer {
    background-color: rgba(63, 86, 115, 0.6);
    bottom: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    .label {
      font-size: 12px;
      color: #DDDDDD;
      padding-left: 5px;
    }

    .button {
      cursor: pointer;
      margin: 0 5px;
      color: #DDDDDD;
      font-size: 12px;
    }
  }
}
</style>
